import { render, staticRenderFns } from "./Taobao-shop.vue?vue&type=template&id=248f69ab&"
import script from "./Taobao-shop.vue?vue&type=script&lang=js&"
export * from "./Taobao-shop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports